export const elvis = (object: object = {}, path: string = ''): any =>
  path.split('.').reduce((value, key) => value && value[key], object);
